module.exports = __webpack_public_path__ + "media/sentient.490b1922.mp3";